import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'
import NotAuthorized from './components/401.vue'
import PhotoView from './components/Photo.vue'
import RealtimeView from './components/views/Realtime.vue'
import MapView from './components/views/Map.vue'
import SecteursView from './components/views/secteurs/Secteurs.vue'
import MaterielView from './components/views/materiel/Materiel.vue'
import CantonniersView from './components/views/cantonniers/Cantonniers.vue'
import MaitrisesView from './components/views/maitrises/Maitrises.vue'
import ResetPasswordView from './components/ResetPassword.vue'
import ReportingView from './components/views/reporting/Reporting'
import DemandeView from './components/views/demande/Demande.vue'
import CollectView from './components/views/collecte/Collecte.vue'
import ImplantationMaterielView from './components/views/implentationMateriel/ImplentationMateriel.vue'
import AdministrationUsersView from './components/views/administration/administrationUsers/AdministrationUsers.vue'
import AdministrationModulesView from './components/views/administration/AdministrationBackoffice.vue'
import AdministrationAnomaliesView from './components/views/administration/AdministrationAndroid.vue'
import StatistiquesView from './components/views/administration/Statistiques.vue'
import RgpdView from "./components/views/Rgpd.vue"
import TourneeView from "./components/views/tournees/Tournees.vue"

// Routes
const routes = [
  {
    path: '/login',
    component: LoginView,
    name: 'Login',
  },
  {
    path: '/resetPassword/:maitriseId',
    component: ResetPasswordView,
    name: 'ResetPassword',
  },
  {
    path: '/photo/:id',
    component: PhotoView,
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'realtime',
        component: RealtimeView,
        name: 'Positons GPS en temps réel',
      },
      {
        path: 'map',
        component: MapView,
        name: 'Parcours des tournées en cours et terminées',
      },
      {
        path: 'tournees',
        component: TourneeView,
        name: 'Gestion de tournées',
      },
      {
        path: 'materiels',
        component: MaterielView,
        name: 'Gestion du matériel',
      },
      {
        path: 'maitrises',
        component: MaitrisesView,
        name: 'Gestion des maîtrises',
      },
      {
        path: 'cantonniers',
        component: CantonniersView,
        name: 'Gestion des cantonniers',
      },
      {
        path: 'secteurs',
        component: SecteursView,
        name: 'Gestion des secteurs',
      },
      {
        path: 'reporting',
        component: ReportingView,
        name: 'Reporting',
      },
      {
        path: 'implantation_des_contenants',
        component: ImplantationMaterielView,
        name: 'Implantation des contenants',
      },
      {
        path: '',
        redirect: '/realtime',
        name: 'Temps réel',
      },
      {
        path: 'demandes',
        component: DemandeView,
        name: 'Gestion des demandes',
      },
      {
        path: 'contenants',
        component: CollectView,
        name: 'Gestion des contenants',
      },
      {
        path: 'administration_users',
        component: AdministrationUsersView,
        name: 'Administration des utilisateurs',
      },
      {
        path: 'administration_modules',
        component: AdministrationModulesView,
        name: 'Administration des modules BO',
      },
      {
        path: 'administration_anomalies',
        component: AdministrationAnomaliesView,
        name: 'Administration APK',
      },
      {
        path: 'administration_statistiques',
        component: StatistiquesView,
        name: 'Statistiques',
      },
      {
        path: 'rgpd',
        component: RgpdView,
        name: 'Politique de confidentialité',
      },
    ],
  },
  {
    // 401
    path: '/401',
    component: NotAuthorized,
    name: 'NotAuthorized',
  },
  {
    // not found handler
    path: '*',
    component: NotFoundView,
    name: 'NotFoundView',
  },
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js